import { Grid } from '@mui/material'
import { FormField } from 'global/components/Form'
import { TabCompetencia } from 'pages/FechamentoCompetencia'
import { Fragment } from 'react'

export function FormularioDetalhes({ tab }: { tab: TabCompetencia }) {
    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <FormField name="competencia" label="Competência" disabled />
            </Grid>

            <Grid item xs={6}>
                <FormField name="usuario" label="E-mail do usuário" disabled />
            </Grid>

            {tab === TabCompetencia.FECHAMENTO && (
                <Fragment>
                    <Grid item xs={4}>
                        <FormField
                            name="horaFechamento"
                            label="Hora do fechamento"
                            disabled
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <FormField
                            name="dataFechamento"
                            label="Data do fechamento"
                            disabled
                        />
                    </Grid>
                </Fragment>
            )}

            {tab === TabCompetencia.ABERTURA && (
                <Fragment>
                    <Grid item xs={4}>
                        <FormField
                            name="horaAbertura"
                            label="Hora da abertura"
                            disabled
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <FormField
                            name="dataAbertura"
                            label="Data da abertura"
                            disabled
                        />
                    </Grid>
                </Fragment>
            )}

            <Grid item xs={4}>
                <FormField name="status" label="Status" disabled />
            </Grid>
        </Grid>
    )
}
